var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5795 38.9486C35.5795 34.8309 38.9057 31.4929 43.0088 31.4929L43.0088 7.49373C38.9057 7.49373 35.5796 4.15572 35.5796 0.0380723L7.42937 1.08866e-05C7.42937 4.11766 4.10319 7.45567 0.000131981 7.45567L0.000108807 31.4549C4.10317 31.4549 7.42934 34.7929 7.42934 38.9105L35.5795 38.9486ZM27.2457 19.076L17.5011 13.3913C17.4306 13.3502 17.3506 13.3284 17.269 13.3281C17.1874 13.3279 17.1072 13.3491 17.0364 13.3897C16.9657 13.4304 16.9069 13.489 16.8661 13.5596C16.8252 13.6302 16.8037 13.7104 16.8037 13.7919V25.1585C16.8034 25.2403 16.8246 25.3207 16.8654 25.3915C16.9061 25.4624 16.9648 25.5213 17.0356 25.5621C17.1064 25.603 17.1868 25.6244 17.2685 25.6242C17.3502 25.624 17.4305 25.6022 17.5011 25.561L27.2457 19.8763C27.3156 19.8354 27.3735 19.777 27.4137 19.7068C27.454 19.6366 27.4752 19.5571 27.4752 19.4762C27.4752 19.3952 27.454 19.3157 27.4137 19.2455C27.3735 19.1753 27.3156 19.1169 27.2457 19.076Z",
    fill: "#F1ECE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.c80d52b060d97666abc7671e70d60f65.svg";
export { ForwardRef as ReactComponent };